import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { DataTable } from '@/v2/components/DataTable/tasks/components/data-table';
import { DataTableColumnHeader } from '@/v2/components/DataTable/tasks/components/data-table-column-header';
import { useFetch } from 'use-http';
import _ from 'lodash';
import { format } from 'date-fns';
import {
  useUserDispatch,
  useUserState,
} from '@/components/context/UserContext';
import { getQueryString } from '@/components/constants/visitsQueryStringBuilder';
import { InfoButton } from '@/components/ui/shared/InfoButton';
import { useHistory } from 'react-router-dom'; // ✅ Import

export default function CouponsTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [Filters, setFilters] = useState();
  const [SelectedFilter, setSelectedFilter] = useState();
  const [search, setSearch] = useState();
  const userState = useUserState();
  const sessionDispatch = useUserDispatch();
  const [dateRange, setDateRange] = useState(userState.dateFilter);
  const history = useHistory(); // ✅ Hook for navigation

  const { get: getData, response: getDataResponse } = useFetch(
    '/UserAccount/UserCoupons',
  );

  const { get: getDetails } = useFetch('/UserAccount/UserCouponDetails');
  const { get: getUsageDetails } = useFetch('/UserAccount/UserCouponUsage');

  const applyChanges = async (date, search, filter) => {
    setLoading(true);
    sessionDispatch({
      type: 'UPDATE',
      data: {
        dateFilter: date,
      },
    });

    const response = await getData(
      getQueryString(date, search, null, filter, userState.espbiEsi),
    );

    if (getDataResponse.ok && response) {
      setData(response);

      if (!Filters && response.length > 0) {
        const tmpFilterArray = [];
        const uniqueStatusIds = [
          ...new Set(response.map((item) => item.statusId)),
        ];

        const order = [
          'Galioja',
          'Panaudotas',
          'Rezervuotas',
          'Nebegalioja',
          'Patvirtintas',
          'Darbinis',
          'Anuliuotas',
        ];

        const sortedStatuses = uniqueStatusIds.sort((a, b) => {
          const indexA = order.indexOf(a);
          const indexB = order.indexOf(b);
          return indexA - indexB;
        });

        const otherStatuses = uniqueStatusIds.filter(
          (status) => !order.includes(status),
        );
        const finalStatuses = sortedStatuses.concat(otherStatuses);

        finalStatuses.forEach((filter) => {
          tmpFilterArray.push({ value: filter, label: filter });
        });
        setFilters(tmpFilterArray);
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    applyChanges(dateRange, search, SelectedFilter);
  }, []);

  const handleSelection = async (obj) => {
    setLoading(true);

    let data = obj;
    const query = userState.espbiEsi
      ? `?id=${obj.id}&espbiEsi=${userState.espbiEsi}`
      : `?id=${obj.id}`;

    await getDetails(query).then((res) => {
      data = { ...data, ...res };
    });

    await getUsageDetails(query).then((res) => {
      data = { ...data, ...res };
    });

    setLoading(false);

    history.push('/userAccount/coupons/details', { data }); // ✅ Redirect with data
  };

  return (
    <DataTable
      title="Kuponai"
      columns={columns({ handleSelection })}
      data={_.orderBy(data, ['id'], ['desc'])}
      filterableColumns={['name', 'number', 'statusId']}
      loading={loading}
      onRowClick={(row) => handleSelection(row)}
    />
  );
}

const columns = ({ handleSelection }) => [
  {
    accessorKey: 'name',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="KUPONAS" />
    ),
    cell: ({ row }) => (
      <span className="font-medium max-w-[400px] truncate">
        {row.original.name} – {row.original.number}
      </span>
    ),
  },
  {
    accessorKey: 'statusId',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="BŪSENA" />
    ),
    cell: ({ row }) => {
      const statusId = row.original.statusId;
      const variant = statusId === 'Galioja' ? 'success' : 'neutral';

      return <Badge variant={variant}>{statusId}</Badge>;
    },
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) => (
      <div className="flex justify-end">
        <InfoButton
          onClick={(e) => {
            e.stopPropagation();
            handleSelection(row.original);
          }}
        >
          Informacija
        </InfoButton>
      </div>
    ),
  },
];
